module.exports = __webpack_public_path__ + "img/expiry-date-tooltip.98dccff8.svg";